import React from 'react';

const Pagination = ({setPageNumber , page , totalPage}) => {
    const pagechanging = (number) => {
        setPageNumber(number);
        // console.log("zahra")
      };
      const nextpage = () => {
        setPageNumber(page + 1);
      };
      const prevpage = () => {
        setPageNumber(page - 1);
      };
    return (
        <div>
        <div className="d-flex w-100 flex-column" style={{ cursor: "pointer" }}>
        {totalPage === 1 ? null : totalPage === 2 ? (
          <div className="align-self-center">
            <nav aria-label="Page navigation example ">
              <ul className="pagination">
                <li className="page-item">
                  <p
                    className="page-link"
                    onClick={() => {
                      pagechanging(1);
                    }}
                  >
                    1
                  </p>
                </li>
                <li className="page-item">
                  <p
                    className="page-link"
                    onClick={() => {
                      pagechanging(2);
                    }}
                  >
                    2
                  </p>
                </li>
              </ul>
            </nav>
          </div>
        ) : totalPage > 2 ? (
          <div className="align-self-center">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <p
                    className="page-link"
                    aria-label="Previous"
                    onClick={() => {
                      prevpage();
                    }}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </p>
                </li>
                <li className="page-item">
                  <p
                    className="page-link"
                    onClick={() => {
                      pagechanging(1);
                    }}
                  >
                    1
                  </p>
                </li>
                <li className="page-item">
                  <p
                    className="page-link"
                    onClick={() => {
                      pagechanging(2);
                    }}
                  >
                    2
                  </p>
                </li>
                <li className="page-item">
                  <p
                    className="page-link"
                    onClick={() => {
                      pagechanging(3);
                    }}
                  >
                    3
                  </p>
                </li>
                <li>
                  <p
                    className="page-link"
                    aria-label="Next"
                    onClick={() => {
                      nextpage();
                    }}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </p>
                </li>
              </ul>
            </nav>
          </div>
        ) : null}
      </div>
        </div>
    );
};

export default Pagination;